import type { ListToolbarVariant } from '../ListToolbar.types'
import type { ListToolbarPosition } from './listToolbarPosition'

interface ResolveListToolbarVariantInput {
  /** Die Seite hat eine Pinnwand (nicht im Listen-Modus, nicht in Kurz notiert). */
  canvasAvailable: boolean
  canvasOpen: boolean
  /** Die Liste ist breit genug für `short`. */
  roomForShort: boolean
  position: ListToolbarPosition
  /** Am Rand: gerade überfahren und ausgefahren. */
  expanded: boolean
  /** `false` in Kurz notiert — dort gibt es nur „Neue Aufgabe" (`addOnly`). */
  sectionsAllowed: boolean
  /** Mindestens zwei Aufgaben sind markiert (#291): Am Rand fährt sie dafür von selbst aus. */
  selecting?: boolean
}

/**
 * Welche Gestalt die **Listen-Werkzeug-Pille** in der Aufgabenliste hat.
 *
 * Notiz und Memo stehen nur bei geschlossener Pinnwand darin — offen hat die
 * Pinnwand ihre eigene Pille. Am Rand ruht sie eingeklappt und fährt beim
 * Überfahren zu dem aus, was sie in der Mitte wäre — und solange eine Auswahl
 * ihre Befehle braucht (#291).
 */
export function resolveListToolbarVariant({
  canvasAvailable, canvasOpen, roomForShort, position, expanded, sectionsAllowed, selecting = false,
}: ResolveListToolbarVariantInput): ListToolbarVariant {
  if (position !== 'center' && !expanded && !selecting) return 'justAdd'
  if (!sectionsAllowed) return 'addOnly'
  if (canvasAvailable && !canvasOpen) return roomForShort ? 'short' : 'compact'
  return 'listOnlyShort'
}
